/* SOARDISTUSA – two-tier header (like SOARDISTPLUS) for the Motion theme.
   Top row: logo + search bar + Upload / Orders / Account / Cart with labels.
   Bottom row: the full main menu on one full-width line.
   Layout only applies on desktop (>= 990px, see sd-header.css); mobile keeps the theme's drawer header. */
(function () {
  'use strict';
  var ICONS = {
    upload: '<svg class="sdh-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>',
    orders: '<svg class="sdh-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8M12 13v8"/></svg>',
    search: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>'
  };

  function decorate(icons) {
    icons.querySelectorAll('.ahl a.ahl__l').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      var ic = h.indexOf('upload') > -1 ? ICONS.upload : h.indexOf('orders') > -1 ? ICONS.orders : '';
      if (ic && !a.querySelector('.sdh-ico')) a.insertAdjacentHTML('afterbegin', ic);
    });
    var acc = icons.querySelector('.ahl-acc__btn');
    if (acc && !acc.querySelector('.sdh-lbl')) acc.insertAdjacentHTML('beforeend', '<span class="sdh-lbl">Account</span>');
    var cart = icons.querySelector('.js-drawer-open-cart');
    if (cart && !cart.querySelector('.sdh-lbl')) cart.insertAdjacentHTML('beforeend', '<span class="sdh-lbl">Cart</span>');
  }

  function build() {
    var header = document.getElementById('SiteHeader');
    if (!header || header.dataset.sdh) return;
    var layout = header.querySelector('.header-layout');
    var nav = layout && layout.querySelector('.header-item--navigation');
    var icons = layout && layout.querySelector('.header-item--icons');
    if (!layout || !nav || !icons) return;
    header.dataset.sdh = '1';

    // search bar between logo and icons
    var f = document.createElement('form');
    f.className = 'sdh-search';
    f.action = (window.theme && theme.routes && theme.routes.search) || '/search';
    f.method = 'get';
    f.setAttribute('role', 'search');
    f.innerHTML = '<input type="search" name="q" placeholder="Search tents, flags, banners, apparel…" aria-label="Search" autocomplete="off">' +
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<button type="submit">' + ICONS.search + '<span>Search</span></button>';
    layout.insertBefore(f, icons);

    // menu goes to its own full-width row under the top row
    var row = document.createElement('div');
    row.className = 'sdh-nav';
    row.appendChild(nav);
    layout.parentNode.insertBefore(row, layout.nextSibling);

    // hover-to-open menus (the theme's own hover handler only covers the original menu position)
    row.querySelectorAll('li').forEach(function (li) {
      var d = li.querySelector(':scope > details');
      if (!d) return;
      var t;
      li.addEventListener('mouseenter', function () {
        clearTimeout(t);
        if (!li.parentElement.closest('details')) {
          row.querySelectorAll('.site-nav > li > details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        }
        d.setAttribute('open', '');
      });
      li.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); }, 120); });
    });

    decorate(icons);
    // Upload / Orders / Account come from the account-header-links section, which moves in later
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { decorate(icons); });
      mo.observe(icons, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    window.addEventListener('load', function () { decorate(icons); });

    header.classList.add('sdh-on');
    // let the theme re-measure the sticky header height
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
